"use strict";
require.context("../images", true);
import "../../../app/packs/entrypoints/decidim_ideal.scss";
const { isTourPathCached } = require("./app-tours/hooks/useStoreTourPaths");
const { useIntroJs } = require("./app-tours/hooks/useIntroJs");
const { useLoadedPage } = require("./app-tours/hooks/useLoadedPage");
const isUserLoggedIn = window.CURRENT_USER !== void 0;
const updateHighContrastButton = () => {
  const isActive = document.documentElement.hasAttribute("data-high-contrast");
  $(".high-contrast-toggle").toggleClass("is-active", isActive).attr("aria-pressed", String(isActive));
};
const initHighContrast = () => {
  updateHighContrastButton();
  $(".high-contrast-toggle").on("click", () => {
    const isActive = document.documentElement.hasAttribute("data-high-contrast");
    if (isActive) {
      document.documentElement.removeAttribute("data-high-contrast");
      localStorage.removeItem("high-contrast");
    } else {
      document.documentElement.setAttribute("data-high-contrast", "true");
      localStorage.setItem("high-contrast", "true");
    }
    updateHighContrastButton();
  });
};
const MAX_FONT_SIZE = 3;
const updateTextSizeUI = (level) => {
  $(".text-size-bar").each(function() {
    const barLevel = parseInt($(this).data("level"), 10);
    $(this).toggleClass("is-active", barLevel <= level);
  });
  $(".text-size-decrease").prop("disabled", level <= 0);
  $(".text-size-increase").prop("disabled", level >= MAX_FONT_SIZE);
};
const setFontSize = (level) => {
  if (level <= 0) {
    document.documentElement.removeAttribute("data-font-size");
    localStorage.removeItem("font-size-level");
  } else {
    document.documentElement.setAttribute("data-font-size", String(level));
    localStorage.setItem("font-size-level", String(level));
  }
  updateTextSizeUI(level);
};
const initTextSize = () => {
  const stored = parseInt(localStorage.getItem("font-size-level") || "0", 10);
  updateTextSizeUI(stored);
  $(".text-size-increase").on("click", () => {
    const current = parseInt(
      document.documentElement.getAttribute("data-font-size") || "0",
      10
    );
    if (current < MAX_FONT_SIZE) setFontSize(current + 1);
  });
  $(".text-size-decrease").on("click", () => {
    const current = parseInt(
      document.documentElement.getAttribute("data-font-size") || "0",
      10
    );
    if (current > 0) setFontSize(current - 1);
  });
};
const startTourManually = () => {
  $(".tour-main_page").on("click", () => {
    useLoadedPage(window.location.pathname).then(
      (steps) => useIntroJs(steps, isUserLoggedIn, window.location.pathname)
    );
  });
};
const initTour = () => {
  if (isUserLoggedIn && !isTourPathCached(window.location.pathname)) {
    useLoadedPage(window.location.pathname).then(
      (steps) => useIntroJs(steps, isUserLoggedIn, window.location.pathname)
    );
  } else {
    startTourManually();
  }
};
$(function() {
  initHighContrast();
  initTextSize();
  initTour();
});
